import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "order-detail-c" }

import { ref } from 'vue';
import { XrkTable, XrkTableProps, XrkTableRef } from 'xrk-components';

import { comprehensiveViewDetails } from '../data-source/apis';
import {
  indexCol,
  fullNameCol,
  phoneCol,
  settlementTaskCountCol,
  taskPriceCol,
  projectPayPriceCol,
  comprehensiveServiceRateCol,
  comprehensiveServiceAmountCol
} from '../fields/columns';


export default /*#__PURE__*/_defineComponent({
  __name: 'comprehensive-order-model',
  props: {
    id: { default: null }
  },
  setup(__props: any) {

const props = __props;

const xrkTableRef = ref<XrkTableRef>();

// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: false
  },
  resetBtn: {
    show: false
  },
  searchColumns: [],
  otherComponents: []
});

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    indexCol,
    fullNameCol,
    phoneCol,
    settlementTaskCountCol,
    taskPriceCol,
    projectPayPriceCol,
    comprehensiveServiceRateCol,
    comprehensiveServiceAmountCol
  ]
});

const getListAjax = async params => {
  const reqData = {
    ...params,
    id: props.id
  };
  const data = await comprehensiveViewDetails(reqData);
  return data;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(XrkTable), {
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value
    }, null, 8, ["searchConfig", "tableConfig"])
  ]))
}
}

})